import FormField from "components/FormField";
import CustomerListItem from "./CustomerListItem";
import SelectedCustomerItem from "./SelectedCustomerItem";
import SortArrow from "../SortArrow/SortArrow";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import styles from "../ContactsTable/ContactsTable.module.scss";

const CustomersTable = ({
  title,
  searchQuery,
  onSearchChange,
  showSearch = true,
  customers,
  selectedCustomerIds,
  onCustomerToggle,
  onCustomerRemove,
  customersLoading,
  customersError,
  hasMore,
  onLoadMore,
  headerActions,
  emptyStateMessage = "No customers found",
  isSelectedCustomersMode = false,
  className,
  sortDirection = null,
  onSortClick,
}) => {
  const { sentinelRef, rootRef, triggerLoadMore } = useInfiniteScroll({
    onLoadMore,
    enabled: Boolean(hasMore) && !customersLoading,
  });

  return (
    <div className={`${styles.panel} ${className || ""}`}>
      <div className={styles.panelHeader}>
        <h4>{title}</h4>
        {headerActions}
      </div>

      <div className={styles.contactsTable}>
        <div className={styles.tableHeader}>
          <div className={styles.headerCell}></div>
          <div className={styles.headerCell}>Customer / MC#</div>
          <div className={styles.headerCell}>
            {onSortClick ? (
              <span
                className={`${styles.sortableLabel} ${sortDirection ? styles.sortActive : ""}`}
                onClick={onSortClick}
              >
                RFQs (30d)
                <SortArrow direction={sortDirection} />
              </span>
            ) : (
              "RFQs (30d)"
            )}
          </div>
        </div>

        {showSearch && (
          <div className={styles.searchRow}>
            <FormField
              fieldName="customerSearch"
              placeholderText="Search customers..."
              value={searchQuery}
              onChange={onSearchChange}
              className={styles.searchInput}
            />
          </div>
        )}

        <div ref={rootRef} className={styles.tableBody}>
          {customersError && (
            <div className={styles.error}>{customersError}</div>
          )}

          {customers.length === 0 && !customersLoading && (
            <div className={styles.emptyState}>
              {isSelectedCustomersMode ? (
                <>
                  <div className={styles.emptyIcon}>📋</div>
                  <div>{emptyStateMessage}</div>
                  <div style={{ fontSize: "0.8rem", marginTop: "0.5rem" }}>
                    Select customers from the left panel
                  </div>
                </>
              ) : searchQuery ? (
                "No customers found matching your search."
              ) : (
                emptyStateMessage
              )}
            </div>
          )}

          {customers.map((customer) =>
            isSelectedCustomersMode ? (
              <SelectedCustomerItem
                key={customer.id}
                customer={customer}
                onRemove={onCustomerRemove}
              />
            ) : (
              <CustomerListItem
                key={customer.id}
                customer={customer}
                isSelected={
                  selectedCustomerIds
                    ? selectedCustomerIds.has(customer.id)
                    : false
                }
                onToggle={onCustomerToggle}
              />
            ),
          )}

          {customersLoading && (
            <div className={styles.loading}>Loading customers...</div>
          )}

          {hasMore && !customersLoading && customers.length > 0 && (
            <div
              ref={sentinelRef}
              className={styles.loadMoreContainer}
              onClick={triggerLoadMore}
            >
              <div className={styles.loadMoreIcon}>↻</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomersTable;
